import bulkPartyoverallen from '../../../../assets/abc-se/accessories/party-overall.jpg';
import bulkFlakoverallen from '../../../../assets/abc-se/accessories/standard-overall.jpg';

/**
 * Bulk product catalog for ABC-SE.
 * Mock data — no backend. Keyed by slug.
 *
 * Future: replace with backend fetch (`/api/bulk-products/{brandSlug}/{slug}`).
 */
export const BULK_PRODUCTS = {
  partyoverallen: {
    slug: 'partyoverallen',
    name: 'Partyoverallen',
    price: '159:-',
    priceRaw: 159,
    description:
      'Classic overall made in 100% cotton with hidden button closure. Specially adapted for dyeing. Hidden button front. Two front pockets. The right front pocket with the zipper. Rule pocket on right leg. Flap pocket on left leg. Adjustable elastic in waistline. Loops in the waist. Reinforced loop on the right leg.',
    images: [
      { src: bulkPartyoverallen, alt: 'Partyoverallen' },
    ],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    minPerSize: 0,
    minTotal: 10,
  },
  flakoverallen: {
    slug: 'flakoverallen',
    name: 'Flakoverallen',
    price: '159:-',
    priceRaw: 159,
    description:
      'Durable standard overall designed for flak parades and outdoor activities. 100% cotton with reinforced seams, adjustable waistline, multiple pockets for utility, and a classic student-style fit. Perfect base for dyeing and customisation.',
    images: [
      { src: bulkFlakoverallen, alt: 'Flakoverallen' },
    ],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    minPerSize: 0,
    minTotal: 10,
  },
};

export const getBulkProduct = (slug) => BULK_PRODUCTS[slug] ?? null;
